export default __webpack_public_path__ + "static/media/addChildDevice.809ade2e.png";